import { LOGO_BOX, LOGO_PATHS } from './logoPaths';

interface LogoProps {
    className?: string;
}

/*
 * The S: two arcs in five hard-edged blocks that run through the house gradient. It is inline so it takes its
 * colours from the section it sits on: --sd-logo-1..5 are the gradient on paper and its bright twin on navy
 * (tokens.css). The size comes from the parent; the shapes are generated (design/logo/generate.py).
 */
const Logo = ({ className }: LogoProps) => (
    <svg className={className} viewBox={LOGO_BOX} aria-hidden="true" focusable="false">
        {LOGO_PATHS.map(([colour, d], i) => (
            <path key={i} d={d} style={{ fill: `var(--sd-logo-${colour})` }} />
        ))}
    </svg>
);

export default Logo;
